import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30bc6038"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "official-doc-preview"
};
const _hoisted_2 = {
  class: "red-template"
};
const _hoisted_3 = {
  class: "company-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_5 = {
  class: "sub-title"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  class: "attach-files"
};
const _hoisted_8 = {
  class: "content-footer"
};
const _hoisted_9 = {
  class: "content-footer-text"
};
import dayjs from 'dayjs';
import { RedTemplateController } from '@/api/generated';
import { useUpload } from '@/common/hooks/useUpload';

import { ref, watch } from 'vue';
const __default__ = {
  name: 'officialDocPreview'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    doc: {}
  },
  setup(__props) {
    const props = __props;
    const {
      getUploadFileUrl
    } = useUpload();
    const seal = ref();
    const redTemplate = ref();
    // const sealImg = computed(() => {
    //   if (seal.value) {
    //     let img = JSON.parse(seal.value.img)[0];
    //     console.log('img is ', img);
    //     return getUploadFileUrl(img, {
    //       id: seal.value.id,
    //       fieldName: 'img',
    //       asImage: true,
    //       filename: img.filename,
    //     });
    //   } else {
    //     return '';
    //   }
    // });
    watch(() => props.doc.redTemplateId, (newValue, oldValue) => {
      if (newValue) {
        RedTemplateController.queryWithSealByRedTemplateId({
          id: newValue
        }).then(res => {
          seal.value = res.data.seal;
          redTemplate.value = res.data.redTemplate;
        });
      } else {
        seal.value = {};
        redTemplate.value = {};
        // sealImg.value = '';
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(redTemplate)?.title || ''), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.doc.enterpriseCharacter) + " （" + _toDisplayString(_ctx.doc.yearStr) + "）第【" + _toDisplayString(_ctx.doc.numStr) + "】号 ", 1), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.doc.title), 1), _createElementVNode("div", {
        class: "content",
        innerHTML: _ctx.doc.content
      }, null, 8, _hoisted_6), false ? (_openBlock(), _createElementBlock("div", _hoisted_7, "附件：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, _toDisplayString(_ctx.doc.sendDept), 1), _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(_ctx.doc.sendDate).format('YYYY-MM-DD')), 1)])])]);
    };
  }
});